import App from './App';
import './style.css';
export default function IntegratedWhatsappApp() { return <div className="agent-shell-whatsapp"><App /></div>; }
